<div class="p-4">
  <mat-dialog-content>
    @if (!loading()) {
      <div class="flex flex-col gap-4">
        <div class="flex items-center justify-between gap-2">
          <h3>{{ "prescription.action.cancelLaboratoryOrder" | translate }}</h3>
          <button mat-dialog-close>
            <mat-icon
              aria-hidden="true"
              aria-label="Close icon"
              fontIcon="close"
            ></mat-icon>
          </button>
        </div>

        @if (prescriptionsInOrder() && prescriptionsInOrder().length > 0) {
          <div class="flex flex-col gap-2">
            <span class="text-sm font-medium">{{ "laboratoryOrder.label.prescriptionsInOrder" | translate }}</span>
            <div class="max-h-60 overflow-y-auto">
              @for (prescription of prescriptionsInOrder(); track prescription.id) {
                <div class="mb-2">
                  <prescriptions-modal-item [prescription]="prescription" />
                </div>
              }
            </div>
          </div>
        }

        @if (data.orderNumber) {
          <div class="flex items-center">
            <span class="min-w-[180px] text-gray-2">{{ "laboratoryOrder.label.orderNumber" | translate }}</span>
            <span>{{ data.orderNumber }}</span>
          </div>
        }

        <shared-warning-message
          [text]="'laboratoryOrder.message.cancellationWarning' | translate: { partner: partnerName(), location: address() }"
          [subText]="'laboratoryOrder.message.cancellationDetails' | translate: { dateTime: startDate() }"
        ></shared-warning-message>
      </div>
    } @else {
      <div class="flex items-center justify-center">
        <shared-loader></shared-loader>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="gap-4">
    @if (!loading()) {
      <button
        class="btn btn-secondary"
        mat-dialog-close
        [type]="'button'"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button
        class="btn btn-primary"
        [type]="'button'"
        (click)="confirmCancellation()"
      >
        {{ "prescription.action.cancelLaboratoryOrder" | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
